import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const warehouseApi = createApi({
  reducerPath: 'warehouseApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Warehouse', 'Movement'],
  endpoints: (builder) => ({
    getLocations: builder.query<unknown[], void>({
      query: () => 'warehouse/locations',
      providesTags: ['Warehouse'],
    }),
    getMovements: builder.query<unknown[], { workOrderId?: string; materialId?: string } | void>({
      query: (params) => ({ url: 'warehouse/movements', params: params || {} }),
      providesTags: ['Movement'],
    }),
    createLocation: builder.mutation<unknown, Record<string, unknown>>({
      query: (body) => ({ url: 'warehouse/locations', method: 'POST', body }),
      invalidatesTags: ['Warehouse'],
    }),
    recordMovement: builder.mutation<unknown, Record<string, unknown>>({
      query: (body) => ({ url: 'warehouse/movements', method: 'POST', body }),
      invalidatesTags: ['Movement', 'Warehouse'],
    }),
  }),
});

export const {
  useGetLocationsQuery,
  useGetMovementsQuery,
  useCreateLocationMutation,
  useRecordMovementMutation,
} = warehouseApi;
